<script>
	import axios from "axios";
	import session from './session.vue';
	import EspressoAux from "@/components/Espresso/EspressoAux.vue";
	import config from "../config/env.config.js";

	const serverUrl = config.ROOT_API;

	const requestErrorHandler = async (error) => {
		console.error(error);

		if (error.message === "Network Error") {
			await EspressoAux.showFailModal("Verifique sua conexão com a internet", "Falha de conexão");
			throw Error("API_CONNECTION_ERROR");
		}

		switch (error.response.status) {
			case 401:
				window.vueRouter.push('/login');
				return;
			case 403:
				if (error.response.data && error.response.data.error) {
					throw Error(error.response.data.error);
				}
				throw Error("API_FORBIDDEN"); // user does not have correct privileges
			case 404:
				throw Error("API_NOT_FOUND");
			case 413:
				throw Error("API_REQUEST_TOO_LARGE");
			case 429:
				throw Error("API_RATE_LIMIT");
			case 500:
				throw Error("API_SERVER_ERROR");
			default:
				throw error.response.data;
		}
	};

	export default {
		send: async function(apiName, command, data, sendToken = false) {
			try {
				//console.log(`v1/${apiName}/${command}`, JSON.stringify(data));
				const response = await axios.request({
					url: `${serverUrl}/v1/${apiName}/${command}`,
					method: "post",
					withCredentials: true,
					data: {
						data,
						token: sendToken ? session.getItem("token") : undefined,
					}
				});
				return response.data;
			} catch (error) {
				return requestErrorHandler(error);
			}
		},
		sendFormData: async function(apiName, command, data) {
			data.append("token", session.getItem("token"));
			//console.log('sendFrom', data);
			try {
				let response = await axios.request({
					url: `${serverUrl}/v1/${apiName}/${command}`,
					method: "post",
					withCredentials: true,
					crossdomain: true,
					data: data,
					headers: { 'Authorization': session.getItem("token") } 
					//headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
				});
				return response.data;
			} catch (error) {
				return requestErrorHandler(error);
			}
		},
		downloadFile: async function(apiName, command, data, sendToken = false) {
			try {
				const response = await axios.request({
					url: `${serverUrl}/v1/${apiName}/${command}`,
					method: "post",
					withCredentials: true,
					responseType: "blob",
					data: {
						data,
						token: sendToken ? session.getItem("token") : undefined,
					}
				});
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', 'laudo.pdf'); // or any other extension
				document.body.appendChild(link);
				link.click();
			} catch (error) {
				return requestErrorHandler(error);
			}
		},
		downloadZip: async function(apiName, command, data, sendToken = false) {
			try {
				const response = await axios.request({
					url: `${serverUrl}/v1/${apiName}/${command}`,
					method: "post",
					withCredentials: true,
					responseType: "blob",
					data: {
						data,
						token: sendToken ? session.getItem("token") : undefined,
					}
				});
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', 'laudos.zip'); // or any other extension
				document.body.appendChild(link);
				link.click();
			} catch (error) {
				return requestErrorHandler(error);
			}
		},
		downloadCsv: async function(apiName, command, data, sendToken = false) {
			try {
				const response = await axios.request({
					url: `${serverUrl}/v1/${apiName}/${command}`,
					method: "post",
					withCredentials: true,
					responseType: "string",
					data: {
						data,
						token: sendToken ? session.getItem("token") : undefined,
					}
				});

				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', 'export.xlsx'); // or any other extension
				document.body.appendChild(link);
				link.click();
			} catch (error) {
				return requestErrorHandler(error);
			}
		},
	}
</script>
